module.exports = __webpack_public_path__ + "static/media/header_slide_09.ae9c41ea.jpg";